import { defineMessages } from "react-intl";

export const Errors = defineMessages({
    NoDevice: {
        id: "Errors.NoDevice",
        defaultMessage: "No reader device connected",
    },
} as const);

export const EnrollmentMessages = defineMessages({
    DeviceServerError: {
        id: "Enrollment.DeviceServerError",
        defaultMessage: "An error occurred while finalizing enrollment, try again",
    },
    Complete: {
        id: "Enrollment.Complete",
        defaultMessage: "You are now registered",
    },
} as const);

export const Messages = defineMessages({
    DeviceRetry: {
        id: "DeviceRetry",
        defaultMessage: "No hit, please retry",
    },
    StampRegistered: {
        id: "StampRegistered",
        defaultMessage: "Clocking registered",
    },
    StampRegisteredOffline: {
        id: "StampRegisteredOffline",
        defaultMessage: "Clocking registered offline",
    },
} as const);

export const Headlines = defineMessages({
    SelectCompany: {
        id: "Headlines.SelectCompany",
        defaultMessage: "Select company:",
    },
} as const);

export const StampContext = defineMessages({
    AlreadyStampedConfirm: {
        id: "StampContext.AlreadyStampedConfirm",
        defaultMessage: "Would you like to clock {direction, select, In {in} other {out}} again?",
    },
    AlreadyStampedHeader: {
        id: "StampContext.AlreadyStampedHeader",
        defaultMessage: "You are already clocked {direction, select, In {in} other {out}}",
    },
    ChangedCostDivision: {
        id: "StampContext.ChangedCostDivision",
        defaultMessage: "You changed department {ago} at {timex, time, short} to {costDiv}.",
    },
    MissingTask: {
        id: "StampContext.MissingTask",
        defaultMessage:
            "You are missing a shift{costDiv, select, null {} other {, your time will be recorded on {costDiv}}}!",
    },
    StampedIn: {
        id: "StampContext.StampedIn",
        defaultMessage: "You clocked {direction} {ago} at {timex, time, short} on {costDiv}.",
    },
    TaskReady: {
        id: "StampContext.TaskReady",
        defaultMessage:
            "Your shift {isPast, select, true {started} other {starts}} at {start, time, short} on {costDiv}.",
    },
    TaskReadyPast: {
        id: "StampContext.TaskReadyPast",
        defaultMessage: "Your shift {isPast, select, true {ended} other {ends}} at {end, time, short} on {costDiv}.",
    },
    EarlyInStamp: {
        id: "StampContext.EarlyIn",
        defaultMessage: "Early clock in!",
    },
    EarlyOutStamp: {
        id: "StampContext.EarlyOut",
        defaultMessage: "Early clock out!",
    },
    LateInStamp: {
        id: "StampContext.LateIn",
        defaultMessage: "Late clock in!",
    },
    LateOutStamp: {
        id: "StampContext.LateOut",
        defaultMessage: "Late clock out!",
    },
    ChooseReason: {
        id: "StampContext.ChooseReason",
        defaultMessage: "Choose a reason:",
    },
    ChooseCostDivision: {
        id: "StampContext.ChooseCostDivision",
        defaultMessage: "Choose one department:",
    },
} as const);
